import { render } from "./Details.vue?vue&type=template&id=e7b65a84&scoped=true&ts=true&lang=pug"
import script from "./Details.vue?vue&type=script&setup=true&lang=ts"
export * from "./Details.vue?vue&type=script&setup=true&lang=ts"

import "./Details.vue?vue&type=style&index=0&id=e7b65a84&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7b65a84"]])

export default __exports__